module.exports = __webpack_public_path__ + "static/media/logo_side@3x.1bab1803.png";